import { render, staticRenderFns } from "./UnarchiveCandidate.vue?vue&type=template&id=5c86e8c0&scoped=true&lang=pug"
import script from "./UnarchiveCandidate.vue?vue&type=script&lang=ts"
export * from "./UnarchiveCandidate.vue?vue&type=script&lang=ts"
import style0 from "./UnarchiveCandidate.vue?vue&type=style&index=0&id=5c86e8c0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c86e8c0",
  null
  
)

export default component.exports